export const LocalStorageKeys = {
  USER_STATS_KEY: "user-stats",
  USER_KEY: "user",
  ACCESS_TOKEN_KEY: "accessToken",
  ID_HEADER_KEY: "idHeader",
  LIFESTYLE_KEY: "lifestyle",
  FAVORITE_CUISINES_KEY: "favorite-cuisines",
  NUTRITIONAL_REQUIREMENT_KEY: "nutritional-requirement",
  SWAP_PLAN_MEAL_INDEX: "swap-plan-meal-index",
  SWAP_PLAN_MEAL_DATA: "swap-plan-meal-data",
  SWAP_PLAN_SEARCH_PARAMS: "swap-plan-search-params",
  SWAP_PLAN_REOPEN_SEARCH_MODAL: "swap-plan-reopen-search-modal",
  EXTRA_FOOD_REOPEN_SAVED_FOODS_MODAL: "extra-food-reopen-saved-foods-modal",
  YOUR_FOODS_REOPEN_MODAL: "your-foods-reopen-modal",
  PLAN_DETAIL_MEAL_DATA: "plan-detail-meal-data",
  HAS_SIGNED_IN_BEFORE_KEY: "has-signed-in-before",
  SHOW_CALORIES_AND_MACROS_KEY: "show-calories-and-macros",
  DEVELOPER_MODE_KEY: "developer-mode",
  NEW_UI_KEY: "new-ui",
  AVATAR_CACHE_BUST_KEY: "avatar-cache-bust",
  EDIT_YOUR_FOOD_REQUEST_KEY: "edit-your-food-request",
  VEG_SIDES_SUCCESS_TOAST_DATE_KEY: "veg-sides-success-toast-date",
  CHAT_SESSION_ID_KEY: "chat-session-id",
  CHAT_MESSAGES_KEY: "chat-messages",
  CHAT_LAST_ACTIVITY_KEY: "chat-last-activity",
  CHAT_ORIGIN_KEY: "chat-origin",
  CHAT_PENDING_IMAGE_KEY: "chat-pending-image",
  CHAT_PENDING_IMAGES_KEY: "chat-pending-images",
  CHAT_CAMERA_IN_PROGRESS_KEY: "chat-camera-in-progress",
  CHAT_WELCOME_PENDING_KEY: "chat-welcome-pending",
  CHAT_OPEN_KEY: "chat-open",
  CHAT_PENDING_TURN_KEY: "chat-pending-turn",
  CHAT_PLAN_FOOD_BADGES_KEY: "chat-plan-food-badges",
  ONBOARDING_V5_ANALYTICS_KEY: "onboarding-v5-analytics",
  CLERK_SESSION_INFO_KEY: "clerk-session-info",
} as const;
